import { useFetcher, useParams } from '@remix-run/react';
import { useTranslation } from 'react-i18next';

import Button from '~/components/Button';
import StatusInputs from '~/components/Forms/StatusInputs';

import useToast from '~/hooks/useToast';

const ResubscribeAction = () => {
  const fetcher = useFetcher();
  const params = useParams();
  const { subscriberId } = params;
  const fetcherData = fetcher.data;
  const isSubmitting = fetcher.state === 'submitting';
  const { t } = useTranslation();

  useToast(fetcherData?.toast);

  return (
    <fetcher.Form method="post" action="/resubscribe">
      <input hidden name="subscriber_id" defaultValue={subscriberId} />
      <StatusInputs
        name="resubscribe"
        errorMessage={t('account_actions.downgrade.toast.error')}
        successMessage={t('account_actions.downgrade.toast.resubscribed')}
      />
      <Button type="submit" variant="primary" isLoading={isSubmitting}>
        {isSubmitting ? `${t('shared.actions.resubscribing')}…` : t('shared.cta.resubscribe')}
      </Button>
    </fetcher.Form>
  );
};

export default ResubscribeAction;
